export const formatSPGByName = (spgs: string[]) => {
  const splitSPGs = spgs.map((spg) => {
    const [name, iri] = spg.split('=');
    return { name, iri };
  });

  const sensitivePropertyGroupsByName: Record<string, string[]> = {};

  new Set(splitSPGs.map((spg) => spg.name || '')).forEach((groupName) => {
    const group = splitSPGs.filter((spg) => spg.name === groupName);
    sensitivePropertyGroupsByName[groupName] = group.map((spg) => spg.iri);
  });

  return sensitivePropertyGroupsByName;
};
